const ageOptions = {
  EighteenToTwentyFive: {
    id: 'EighteenToTwentyFive',
    labelKey: 'Audience_Campaign_Target_Setting_Age_Eighteen',
  },
  TwentyFiveToThirtyFive: {
    id: 'TwentyFiveToThirtyFive',
    labelKey: 'Audience_Campaign_Target_Setting_Age_TwentyFive',
  },
  ThirtyFiveToFifty: {
    id: 'ThirtyFiveToFifty',
    labelKey: 'Audience_Campaign_Target_Setting_Age_ThirtyFive',
  },
  FiftyToSixtyFive: {
    id: 'FiftyToSixtyFive',
    labelKey: 'Audience_Campaign_Target_Setting_Age_Fifty',
  },
  SixtyFiveAndAbove: {
    id: 'SixtyFiveAndAbove',
    labelKey: 'Audience_Campaign_Target_Setting_Age_SixtyFive',
  },
  Unknown: {
    id: 'Unknown',
    labelKey: 'Audience_Campaign_Target_Setting_Age_Unknown',
  },
};

const allAgeOptions = {
  ...ageOptions,
  // LinkedIn specific age options
  ThirtyFiveToFiftyFive: {
    id: 'ThirtyFiveToFiftyFive',
    labelKey: 'Audience_Campaign_Target_Setting_Age_ThirtyFiveToFiftyFive',
  },
  FiftyFiveAndAbove: {
    id: 'FiftyFiveAndAbove',
    labelKey: 'Audience_Campaign_Target_Setting_Age_FiftyFiveAndAbove',
  },
};

const genderOptions = {
  Female: {
    id: 'Female',
    labelKey: 'Audience_Campaign_Target_Setting_Gender_Female',
  },
  Male: {
    id: 'Male',
    labelKey: 'Audience_Campaign_Target_Setting_Gender_Male',
  },
  Unknown: {
    id: 'Unknown',
    labelKey: 'Audience_Campaign_Target_Setting_Gender_Unknown',
  },
};

const deviceOptions = {
  Computers: {
    id: 'Computers',
    labelKey: 'Audience_Campaign_Target_Setting_Device_Desktop',
  },
  Tablets: {
    id: 'Tablets',
    labelKey: 'Audience_Campaign_Target_Setting_Device_Tablet',
  },
  Smartphones: {
    id: 'Smartphones',
    labelKey: 'Audience_Campaign_Target_Setting_Device_Smartphone',
  },
};

const ageSettingOptions = {
  titleKey: 'Audience_Campaign_Target_Setting_Age_Title',
  helpKey: 'pop_BA_CampaignCreate_AudTargets_Age',
  descriptionKey: 'Audience_Campaign_Target_Setting_Age_Description',
  selections: ageOptions,
  targetTypePrefix: 'AgeType',
  criterionType: 'Age',
  criterionTypeTarget: 'Target',
};

const deviceSettingOptions = {
  titleKey: 'Audience_Campaign_Target_Setting_Device_Title',
  helpKey: 'pop_BA_CampaignCreate_AudTargets_Device',
  descriptionKey: 'Audience_Campaign_Target_Setting_Device_Description',
  selections: deviceOptions,
  targetTypePrefix: 'DeviceType',
  criterionType: 'Device',
  criterionTypeTarget: 'DeviceName',
};

const genderSettingOptions = {
  titleKey: 'Audience_Campaign_Target_Setting_Gender_Title',
  helpKey: 'pop_BA_CampaignCreate_AudTargets_Gender',
  descriptionKey: 'Audience_Campaign_Target_Setting_Gender_Description',
  selections: genderOptions,
  targetTypePrefix: 'GenderType',
  criterionType: 'Gender',
  criterionTypeTarget: 'Target',
};

export {
  allAgeOptions,
  ageSettingOptions,
  deviceSettingOptions,
  genderSettingOptions,
  ageOptions,
  genderOptions,
  deviceOptions
};
